import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../Footer/FooterBottom";
import AdvancedSearchForm from "./components/AdvancedSearchForm";
import SchoolsTable from "./components/SchoolsTable";
import SchoolModals from "./components/SchoolModals";
import useSchoolFilters from "./hooks/useSchoolFilters";
import useSchoolActions from "./hooks/useSchoolActions";
import "../Users/Users.css";

const SchoolsList = () => {
    const {
        search,
        setSearch,
        filters,
        setFilters,
        isStartSearch,
        countries,
        handleSearchSync,
        handleClearFilters,
        schoolsList,
        isSchoolsLoaded,
        toRemoveList,
        t,
    } = useSchoolFilters();

    const {
        activeModal,
        selectedSchool,
        schoolUsers,
        loadingSchoolUsers,
        activeAdminUser,
        setActiveAdminUser,
        handleCloseModal,
        handleActionTrigger,
        handleSubmitAdd,
        handleSubmitEdit,
    } = useSchoolActions({ handleSearchSync });

    const [isAdvSearchOpen, setIsAdvSearchOpen] = useState(false);

    return (
        <>
            <Helmet>
                <title>
                    {t("Pages.SchoolsControl.title")} | {t("alarabeyya")}
                </title>
            </Helmet>

            <section className="users-page-section">
                <div className="container-fluid px-lg-5 users-container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            {/* Page Header */}
                            <div className="users-page-header">
                                <h2 className="users-page-title">{t("Pages.SchoolsControl.title")}</h2>
                                <div className="users-title-accent"></div>
                            </div>

                            {/* Toolbar: Search + Count + Add */}
                            <div className="users-toolbar-wrapper w-100 mb-4">
                                <div className="users-toolbar d-flex align-items-center justify-content-between gap-3 flex-wrap">
                                    <div
                                        className="users-toolbar-search d-flex align-items-center gap-2 flex-grow-1"
                                        style={{ maxWidth: "520px" }}
                                    >
                                        <div className="search-box-container flex-grow-1">
                                            <div className="search-box-inner">
                                                <i className="fas fa-search search-box-icon"></i>
                                                <input
                                                    type="text"
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    value={search}
                                                    placeholder={t("Pages.SchoolsControl.search")}
                                                    className="search-box-input"
                                                />
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            className={`btn adv-search-toggle-btn d-flex align-items-center justify-content-center px-3 gap-2 ${
                                                isAdvSearchOpen ? "active" : ""
                                            }`}
                                            onClick={() => setIsAdvSearchOpen(!isAdvSearchOpen)}
                                            title={t("Pages.UsersControl.toggleSearch")}
                                            style={{
                                                borderRadius: "22px",
                                                height: "44px",
                                                width: "150px",
                                            }}
                                        >
                                            <i className="fal fa-sliders-h ml-2"></i>
                                            <span style={{ fontWeight: "600", fontSize: "0.9rem" }}>
                                                {t("Pages.UsersControl.toggleSearch")}
                                            </span>
                                        </button>
                                    </div>

                                    <div className="users-toolbar-actions align-self-start">
                                        {isSchoolsLoaded && (
                                            <div className="users-count-badge">
                                                <span className="users-count-label">
                                                    {t("Pages.UsersControl.advancedSearch.total")}
                                                </span>
                                                <span className="users-count-value">
                                                    {
                                                        schoolsList.filter((v) =>
                                                            v.Name.toLowerCase().includes(
                                                                search.toLowerCase()
                                                            )
                                                        ).length
                                                    }
                                                </span>
                                            </div>
                                        )}
                                        <button
                                            type="button"
                                            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2"
                                            onClick={() => handleActionTrigger("add", null, t)}
                                            style={{
                                                height: "44px",
                                                borderRadius: "22px",
                                                fontWeight: "600",
                                            }}
                                        >
                                            <i className="fas fa-plus ml-2"></i>
                                            <span>{t("Pages.SchoolsControl.Add")}</span>
                                        </button>
                                    </div>
                                </div>

                                {/* Advanced Search Form */}
                                <AdvancedSearchForm
                                    show={isAdvSearchOpen}
                                    filters={filters}
                                    setFilters={setFilters}
                                    onSearch={() => handleSearchSync()}
                                    onClear={handleClearFilters}
                                    countries={countries}
                                    t={t}
                                />
                            </div>

                            {/* Schools Table / Card list */}
                            {isStartSearch && (
                                <SchoolsTable
                                    schools={schoolsList}
                                    isLoaded={isSchoolsLoaded}
                                    toRemove={toRemoveList}
                                    onAction={handleActionTrigger}
                                    searchKey={search}
                                    countries={countries}
                                    t={t}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* School Modals */}
            <SchoolModals
                activeModal={activeModal}
                selectedSchool={selectedSchool}
                schoolUsers={schoolUsers}
                loadingSchoolUsers={loadingSchoolUsers}
                activeAdminUser={activeAdminUser}
                setActiveAdminUser={setActiveAdminUser}
                countries={countries}
                onClose={handleCloseModal}
                onSubmitAdd={(postData, toastId) => handleSubmitAdd(postData, toastId, t)}
                onSubmitEdit={handleSubmitEdit}
                onAction={handleActionTrigger}
                t={t}
            />

            <Footer />
        </>
    );
};

export default SchoolsList;
